import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import LegalAccordion from './LegalAccordion';

const termsSections = [
  {
    title: '1. Use of the service',
    body: (
      <p>
        FamConnect26 is a family connection platform that helps families organize information, build and
        maintain family trees, share events and messages, and stay connected across generations. You agree
        to use the service only for lawful purposes and in a way that respects other members of your family
        network. You may not use FamConnect26 to distribute spam, harmful content, or material that violates
        the rights of others.
      </p>
    ),
  },
  {
    title: '2. Accounts and eligibility',
    body: (
      <p>
        You must provide accurate registration information and keep your login credentials secure. You are
        responsible for all activity under your account. Family administrators may invite, approve, or
        manage members according to the roles and features available in the app. If you believe your account
        has been accessed without authorization, notify us promptly through the support options in the app.
      </p>
    ),
  },
  {
    title: '3. Family data and content',
    body: (
      <p>
        You retain ownership of information you submit, including names, dates, photos, and other family
        records. You grant FamConnect26 a limited license to host, display, back up, and process that
        information solely to operate, secure, and improve the service. Do not upload content you do not
        have the right to share. Other family members may see information you add based on permissions set
        by your family administrator.
      </p>
    ),
  },
  {
    title: '4. Acceptable conduct and subscriptions',
    body: (
      <>
        <p>
          When using FamConnect26, you agree that you will not harass, impersonate, or mislead other users;
          attempt to access accounts, trees, or data you are not authorized to view; interfere with the
          security or availability of the platform; or use automated tools to scrape or overload the service
          without permission.
        </p>
        <p>
          Paid plans, if applicable, are billed according to the pricing shown at Sign Up or in your account
          settings. You may manage or cancel your subscription through your account or by contacting
          support.
        </p>
      </>
    ),
  },
];

export default function Terms() {
  return (
    <LegalPageLayout title="Terms of Service">
      <LegalAccordion sections={termsSections} idPrefix="terms" />
    </LegalPageLayout>
  );
}
